import type { BannerContent } from '@/core/types';

import { BannerV1 } from '@/containers/blocks/banners';

export default function generate({
  content,
  className,
}: {
  content: BannerContent;
  className?: string;
}) {
  return (
    <BannerV1
      title={content.title}
      titleTag={content.titleTag}
      subTitle={content.subtitle}
      button={content.button || undefined}
      image={content.image}
      className={className}
    />
  );
}
